"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function GetBrowserInfo() {
    var agent = String(navigator.userAgent);
    var isIE11 = agent.match(/clr/gi);
    var isIE9 = agent.match(/msie/gi);
    if (isIE11 || isIE9) {
        return alert("Navegador não suportado! É recomendada a utilização dos seguintes navegadores: Google Chrome, Mozilla Firefox ou Microsoft Edge.");
    }
}
exports.default = GetBrowserInfo;
//# sourceMappingURL=BrowserVerification.js.map